import React, { Component } from 'react';
import { connect } from 'react-redux';

class Loading extends Component {

	init() {
		this.setHeight();
		this.setWidth();
		this.setMarginBottom();
		this.setMarginTop();
		this.setMargin();
		this.setFlex();
		this.setCSS();
		this.setAmount();
	}

	setAmount() {
		if ( typeof this.props.amount === 'undefined' || this.props.amount == null ) {
			this.amount = 1;
		} else {
			this.amount = this.props.amount;
		}
	}

	setMarginBottom() {
		if ( typeof this.props.marginBottom === 'undefined' || this.props.marginBottom == null ) {
			this.marginBottom = 0;
		} else {
			this.marginBottom = this.props.marginBottom;
		}
	}

	setMarginTop() {
		if ( typeof this.props.marginTop === 'undefined' || this.props.marginTop == null ) {
			this.marginTop = 0;
		} else {
			this.marginTop = this.props.marginTop;
		}
	}

	setHeight() {

		if ( typeof this.props.height === 'undefined' || this.props.height == null ) {
			this.height = 100;
		} else {
			this.height = this.props.height;
		}
	}

	setWidth() {
		if ( typeof this.props.width === 'undefined' || this.props.width == null ) {
			this.width = 300;
		} else {
			this.width = this.props.width;
		}
	}

	setMargin() {
		if ( typeof this.props.margin === 'undefined' || this.props.margin == null ) {
			this.margin = 5;
		} else {
			this.margin = this.props.margin;
		}
	}

	setFlex() {
		if ( typeof this.props.flex === 'undefined' || this.props.flex == null ) {
			this.flex = false;
		} else {
			this.flex = this.props.flex;
		}
	}

	setCSS() {
		this.css = {
			height      : this.height,
			width       : this.width,
			margin      : this.margin,
			marginBottom: this.marginBottom,
			marginTop   : this.marginTop
		};
	}

	createLoaders() {
		const amount_of_loaders = this.amount;
		const loaders = [...Array( amount_of_loaders )].map( ( _, i ) => {
			return (
				<div className="animated-background" style={ this.css }></div>
			);
		} );
		return loaders;
	}

	render() {
		this.init();
		return (<div className={ this.flex
		                         ? 'd-flex'
		                         : '' }>{ this.createLoaders() }</div>
		);
	}
}

function mapStateToProps() {
	return {};
}

export default connect( mapStateToProps, {} )( Loading );